import { z } from "zod"

export const paginationOptionsSchema = z.object({
  pageIndex: z
    .string()
    .refine((str) => /^\d+$/.test(str), {
      message: "pageIndex must be a stringified number",
    })
    .transform(Number),
  pageSize: z
    .string()
    .refine((str) => /^\d+$/.test(str), {
      message: "pageSize must be a stringified number",
    })
    .transform(Number),
})
